import {
  buttonSaveUpdate,
  formEditUser,
  modalUpdateUserSubTitle,
  modalUpdateUserTitle,
  snackbarSummaryUpdatesSaved,
  snackbarUserUpdated,
} from "_constants";
import { FormAddUser } from "components/form/FormAddUser";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import { useConfirmDialogExit } from "hooks";
import { User } from "interfaces";
import { useSnackbar } from "providers/SnackbarProvider";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { updateUser } from "services";
import { setPageUtenti } from "store/slicer/GestioneUsersSlice";
import { useAppDispatch } from "store/store";

export const ModalEditUser = ({
  showModal,
  user,
  closeModalEditUserCallback,
}: {
  showModal: boolean;
  user: User;
  closeModalEditUserCallback: Function;
}) => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control, trigger, getValues } = useForm({
    defaultValues: {
      name: "",
      lastName: "",
      email: "",
      role: 0,
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  useEffect(() => {
    if (user?.id) {
      control._reset({
        name: user?.name,
        lastName: user?.lastName,
        email: user?.email,
        role: user?.role ?? 0,
      });
    }
  }, [user, control]);

  const onSubmit = (formData: any) => {
    formData.id = user.id;
    updateUser(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarSummaryUpdatesSaved,
          detail: snackbarUserUpdated,
          life: 5000,
        });
        dispatch(setPageUtenti(-1));
        setTimeout(() => {
          dispatch(setPageUtenti(1));
        }, 200);
        resetFormState();
      })
      .catch((_: any) => {});
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    closeModalEditUserCallback();
    control._reset();
  };

  return (
    <SingleStepDialog
      onHideCallback={handleDismiss}
      height="333px"
      width="700px"
      header={
        <SingleStepHeaders
          title={modalUpdateUserTitle}
          subtitle={modalUpdateUserSubTitle}
        />
      }
      body={
        <SingleStepBody
          content={
            <form
              id={formEditUser}
              onSubmit={handleSubmit(onSubmit)}
              className="width-100 padd-top-4"
            >
              <FormAddUser
                control={control}
                trigger={trigger}
                getValues={getValues}
              />
            </form>
          }
        />
      }
      footer={
        <SingleStepFooter
          dismiss={handleDismiss}
          form={formEditUser}
          labelSubmit={buttonSaveUpdate}
        />
      }
      display={showModal}
      setVisible={() => {}}
    />
  );
};
